import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";
import yellow from "@material-ui/core/colors/yellow";
import Button from "@material-ui/core/Button";
import CancelIcon from "@material-ui/icons/Cancel";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import Typography from "@material-ui/core/Typography";

import PanelLoadingIndicator from "../components/PanelLoadingIndicator";

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    height: "100%",
  },
  closeButton: {
    position: "absolute",
    top: 4,
    right: 10,
  },
  inputPaper: {
    marginTop: 20,
    padding: "0 8px",
    display: "flex",
    alignItems: "center",
    // backgroundColor: theme.palette.grey[200],
    width: "100%",
  },
  input: {
    flex: 1,
    fontSize: "1.4rem",
    padding: 8,
    fontWeight: 400,
  },
  searchIcon: {
    margin: theme.spacing(1),
  },
  searchResult: {
    fontSize: "1.4rem",
    "& strong": {
      fontWeight: 500,
      backgroundColor: yellow[200],
    },
  },
  resultsLabel: {
    marginTop: 18,
  },
}));

const boldQuery = (query, excerpt) =>
  excerpt.replace(new RegExp(`(${query})`, "ig"), "<strong>$1</strong>");

const SearchDialog = ({
  open,
  loading,
  searchResults,
  onSearch,
  onClose,
  onClear,
  onItemClick,
  ...props
}) => {
  const classes = useStyles();

  const [query, setQuery] = useState("");

  const handleClear = () => {
    setQuery("");
    onClear();
  };

  return (
    <Dialog
      classes={{ paper: classes.dialogPaper }}
      onClose={onClose}
      aria-label="search"
      open={open}
      maxWidth="sm"
      fullWidth={true}
      {...props}
    >
      <DialogTitle id="simple-dialog-title">
        <Typography component="span" variant="h3">
          Search
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        <Paper className={classes.inputPaper} variant="outlined">
          <SearchIcon className={classes.searchIcon} />
          <InputBase
            value={query}
            onChange={e => setQuery(e.target.value)}
            className={classes.input}
            placeholder="Search"
            inputProps={{ "aria-label": "search" }}
            onKeyDown={event => {
              if (event.key === "Enter") {
                onSearch(event.target.value);
              }
            }}
          />
          {query && (
            <IconButton aria-label="clear" onClick={handleClear}>
              <CancelIcon />
            </IconButton>
          )}
        </Paper>
      </DialogTitle>
      <DialogContent>
        {loading && <PanelLoadingIndicator />}
        <List>
          {searchResults.map((item, idx) => (
            <>
              <ListItem
                // dense={true}
                button
                onClick={() => onItemClick(item)}
                key={item.excerpt}
              >
                <Typography
                  className={classes.searchResult}
                  variant="body1"
                  dangerouslySetInnerHTML={{
                    __html: boldQuery(query, item.excerpt),
                  }}
                />
                {/*<ListItemText primary={boldQuery(query, item.excerpt)} />*/}
              </ListItem>
              {idx !== searchResults.length - 1 && <Divider />}
            </>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleClear();
            onClose();
          }}
        >
          Clear and close
        </Button>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SearchDialog;
